fx.ns("models", class GooglePhotoModel extends fx.Model {

	constructor(data)
	{
		super(data);
	}

	get defaults()
	{
		return {
			selected: false
		}
	}

	select()
	{
		this.selected = !this.selected;
	}
	
	unSelect()
	{
		//console.log("Unselected")
		// this.selected = false;
	}

});